import React, { useState } from "react";
import { auth, db } from "../../Firebase";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";

const SendMessage = ({ scroll }) => {
  const [message, setMessage] = useState("");

  const sendMessage = async (event) => {
    event.preventDefault();
    if (message.trim() === "") {
        alert("Enter valid message");
        return;
    }
    event.target[1].disabled = true;
    const { uid, displayName, photoURL } = auth.currentUser;
    const docRef = await addDoc(collection(db, "messages"), {
        text: message,
        name: displayName,
        avatar: photoURL,
        createdAt: serverTimestamp(),
        uid,
    });
    setMessage("");
    event.target[1].disabled = false;
  };    
  scroll.current?.scrollIntoView({ behavior: "smooth" });
  return (
    <form onSubmit={(event) => sendMessage(event)} className="send-message">
      <label htmlFor="messageInput" hidden>
        Enter Message
      </label>
      <textarea
        id="messageInput"
        name="messageInput"
        type="text"
        className="form-input__input"
        placeholder="Escribe tu mensaje..."
        value={message}
        onChange={(e) => setMessage(e.target.value)}
      />
      <button type="submit">Enviar</button>
    </form>
  );
};

export default SendMessage;